export default __webpack_public_path__ + "static/char-s-59-zh-Hans-7ef793c9df89469b6817930699264e4b.png";